import { AppComponent } from './app/app.component';
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { PosSyncService } from './app/services/pos-sync.service';

function normalizePublicFeedbackPathToHash() {
  const { origin, pathname, search, hash } = window.location;
  if (hash) return;

  const normalizedPath = pathname.toLowerCase();
  if (normalizedPath.endsWith('/feedback/public') || normalizedPath.includes('/feedback/public')) {
    window.location.replace(`${origin}/#/feedback/public${search || ''}`);
  }
}

async function bootstrap() {
  normalizePublicFeedbackPathToHash();

  try {
    const response = await fetch('/assets/config/portconfig.json');
    const config = await response.json();
    (window as any).appConfig = config;
  } catch (err) {
    console.error('Failed to load config.json:', err);
  }

  const appRef = await bootstrapApplication(AppComponent, appConfig).catch((err) =>
    console.error(err)
  );

  if (!appRef) return;

  const posSyncService = appRef.injector.get(PosSyncService);

  // Keep POS sync listeners active without filling the console during normal navigation.
  navigator.serviceWorker?.addEventListener('message', (ev) => {
    if (ev.data?.type === 'RUN_POS_SYNC') {
      posSyncService.trySyncPending();
    }
  });

  window.addEventListener('online', () => {
    posSyncService.trySyncPending();
  });

  window.addEventListener('run-pos-sync', () => {
    posSyncService.trySyncPending();
  });
}

bootstrap();
